import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Quotation } from "@/v2/types";
import { Pagination } from "@/v2/types/Datatable";

export default async function FindAllQuotations({
    skip,
    limit,
    search,
    order,
    orderBy,
    filter,
}: {
    skip?: number;
    limit?: number;
    search?: string;
    order?: string;
    orderBy?: string;
    filter?: Record<string, string>;
}): Promise<{ data: Quotation[]; pagination: Pagination }> {
    const res = await apiClientWithRefreshToken({
        url: `/quotations`,
        method: "GET",
        params: {
            skip: skip ?? 0,
            limit: limit ?? 10,
            ...(search && { search }),
            ...(order && { order }),
            ...(orderBy && { order_by: orderBy }),
            ...filter,
        },
    });
    return res.data;
}
